export default __webpack_public_path__ + "static/media/feedback.608b5ac4.svg";